import moment from "moment";


/**
 * This function will convert second to HH:MM:SS string.
 * @param seconds : Need to pass the total seconds in number
 * @returns HH:MM:SS  string
 */
export const secondsToTimeFormat = (seconds: number) => {
    return moment.utc(seconds * 1000).format('HH:mm:ss');
}



/**
 * This function will convert HH:mm:ss string to seconds.
 * @param seconds : Need to pass the HH:mm:ss string
 * @returns Total seconds
 */
export const timeFormatToSeconds = (timeString: string) => {
    const parts = timeString.split(':').map(Number);
    const [hours, minutes, seconds] = parts;
    return hours * 3600 + minutes * 60 + seconds;
}




export const dateStringBasedOnTimeZone = (timezone: string) => {
    try {
        // Get the current time in the specified time zone
        const momentInTimeZone = moment.tz(timezone);

        // Convert the time to UTC and return it as an ISO string
        return momentInTimeZone.utc().format();
    } catch (error: any) {
        console.error("Error converting time:", error.message as string);
        return null;
    }
}


export const dateStringForFromAndToStringFormat = (dateString: string, timezone:string) => {
    // const splittedDate = (dateString || "")?.split("T")?.[0]
    // const from = "00:00:01";
    // const to = "23:59:59";
    // const zone = "000Z"
    // const fromDate = `${splittedDate}T${from}.${zone}`
    // const toDate = `${splittedDate}T${to}.${zone}`
    const fromDate = moment.tz(dateString, timezone).startOf('day').toISOString()
    const toDate = moment.tz(dateString, timezone).endOf('day').toISOString()
    return {
        fromDate, toDate
    }
}


export const truncateText = (text: string, maxLength: number) => {
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text
}



export const isDateFromToday = (dateString: string): boolean => {

    // Parse the input date
    const inputDate = new Date(dateString);

    // Get the current date in UTC
    const today = new Date();

    // Check if the year, month, and day match in UTC
    return (
        inputDate.getUTCFullYear() === today.getUTCFullYear() &&
        inputDate.getUTCMonth() === today.getUTCMonth() &&
        inputDate.getUTCDate() === today.getUTCDate()
    );
};
